import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-radio-properties',
  templateUrl: './radio-properties.component.html',
  styleUrls: ['./radio-properties.component.scss']
})
export class RadioPropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: State;
   helper = new EFormHelper();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
   constructor(public translate: TranslateService) { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

  onTypeChange(type: string) {
   if (type === 'checkbox' || type === 'toggle') {
     const _field =  this.getField;
     _field.get('required').patchValue(false);
   }
  }

  get getField() {
    if(this.table){
      return  this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex)
    }else{
      return  this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
    }

  }


  checkType(){
    if(this.table){
      return this.helper.getFieldTableSomeValue(this.eForm, 'type', this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex) === 'radio'
    }else{
      return this.helper.getFieldSomeValue(this.eForm, 'type', this.state.sectionIndex, this.state.fieldIndex) === 'radio'
    }
  }


}
